import React from 'react'
import { graphql, useStaticQuery } from 'gatsby';

const Query = () => {
    const resultQuery = useStaticQuery(
        graphql`
            query {
                allContentfulPequeninTransversal(filter: {titulo: {eq: "Transversal"}}) {
                    nodes {
                    aliadosModalAliados {
                        imagenRetailer {
                        description
                        gatsbyImageData(formats: [AUTO, JPG, WEBP], placeholder: BLURRED)
                        file{
                            url
                        }
                        }
                        nombreCta
                        redireccionRetailer
                        promesaRetailer {
                            raw
                        }
                        isChat
                    }
                    imagenInformacionAdicionalModalAliados {
                        description
                        
                        gatsbyImageData(formats: [AUTO, JPG, WEBP], placeholder: BLURRED)
                        file{
                            url
                        }
                    }
                    informacionAdicionalModalAliados {
                        raw
                    }
                    redireccionInformacionAdicionalModalAliados
                    tituloModalAliados {
                        raw
                    }
                    node_locale
                    }
                }
            } 
        
        `
    )
    return (resultQuery)
}

export default Query
